import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';

import { config } from '../../../../config';
import { PromotionCode } from './promotion-code.model';

interface PromotionCodeResponse {
  data: PromotionCode;
}

interface PromotionCodesResponse {
  data: PromotionCode[];
}

@Injectable()
export class PromotionCodeService {
  constructor(private http: HttpClient) {}

  get(query: string = ''): Observable<PromotionCode[]> {
    return this.http
      .get<PromotionCodesResponse>(`${config.apiLocation}/v1/promotion-codes?${query}`)
      .map(res => res.data);
  }

  getById(id: string): Observable<PromotionCode> {
    return this.http
      .get<PromotionCodeResponse>(`${config.apiLocation}/v1/promotion-codes/${id}`)
      .map(res => res.data);
  }

  create(promotionCode: RecursivePartial<PromotionCode>): Observable<PromotionCode> {
    return this.http
      .post<PromotionCodeResponse>(`${config.apiLocation}/v1/promotion-codes`, promotionCode)
      .map(res => res.data);
  }

  update(id: string, promotionCode: RecursivePartial<PromotionCode>): Observable<PromotionCode> {
    return this.http
      .patch<PromotionCodeResponse>(`${config.apiLocation}/v1/promotion-codes/${id}`, promotionCode)
      .map(res => res.data);
  }

  delete(id: string): Observable<void> {
    return this.http.delete<void>(`${config.apiLocation}/v1/promotion-codes/${id}`);
  }

  restore(id: string): Observable<void> {
    return this.http.patch<void>(`${config.apiLocation}/v1/promotion-codes/${id}/restore`, {});
  }
}



// WEBPACK FOOTER //
// ./src/app/core/data/promotion-codes/promotion-code.service.ts